import React from 'react';
import './LoginForm.css';
import customIcon from '../Assets/KAU_logo.png';

const GoogleSignInWindow = ({ onSignIn }) => {
    const handleGoogleSignIn = async () => {
        try {
            await onSignIn();
        } catch (error) {
            console.error('Error during Google Sign-In:', error);
        }
    };

    return (
        <div>
            <button onClick={handleGoogleSignIn} className='sign-in-button'>
                <p className='text'>
                <img 
                    src={customIcon} 
                    className="icon" 
                    style={{ maxWidth: '100%', height: '30px' }} 
                    
                />
                    Sign in with your Kau Account
                </p>
            </button>
        </div>
    );
};

export default GoogleSignInWindow;